import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Sidebar } from 'primereact/sidebar';
import Logo from './Logo';
import '../layout.css';

const PublicLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  const navigationItems = [
    { path: '/', label: 'Dashboard', icon: 'pi pi-fw pi-home' },
    { path: '/platform', label: 'Platform', icon: 'pi pi-fw pi-cog' },
    { path: '/solutions', label: 'Solutions', icon: 'pi pi-fw pi-lightbulb' },
    { path: '/resources', label: 'Resources', icon: 'pi pi-fw pi-book' },
    { path: '/contact', label: 'Contact', icon: 'pi pi-fw pi-envelope' },
  ];

  const isActivePath = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="layout-wrapper layout-static">
      {/* Sidebar */}
      <div className="layout-sidebar">
        <Link to="/" className="layout-logo">
          <Logo size="md" />
        </Link>

        <div className="layout-menu-container">
          <ul className="layout-menu">
            {navigationItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={isActivePath(item.path) ? 'router-link-active' : ''}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Main Container */}
      <div className="layout-main-container">
        {/* Topbar */}
        <div className="layout-topbar">
          <Link to="/" className="layout-topbar-logo">
            <Logo size="sm" />
          </Link>

          <button
            type="button"
            className="p-link layout-menu-button layout-topbar-button"
            onClick={() => setMobileMenuVisible(true)}
          >
            <i className="pi pi-bars"></i>
          </button>

          <div className="layout-topbar-menu">
            <Button
              label="Sign In"
              icon="pi pi-sign-in"
              className="p-button-text"
              onClick={() => navigate('/login')}
            />
          </div>
        </div>

        {/* Main Content */}
        <div className="layout-main">
          <Outlet />
        </div>

        {/* Footer */}
        <div className="layout-footer">
          <div className="flex justify-content-between align-items-center">
            <div className="flex align-items-center">
              <Logo size="sm" />
              <span className="ml-2 text-600">© 2026 Insights Research. All rights reserved.</span>
            </div>
            <div className="flex gap-3">
              <Link to="/privacy" className="text-600 hover:text-primary no-underline">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-600 hover:text-primary no-underline">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <Sidebar
        visible={mobileMenuVisible}
        position="left"
        onHide={() => setMobileMenuVisible(false)}
        className="layout-sidebar-mobile"
      >
        <Link to="/" className="layout-logo" onClick={() => setMobileMenuVisible(false)}>
          <Logo size="md" />
        </Link>

        <div className="layout-menu-container">
          <ul className="layout-menu">
            {navigationItems.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.path}
                  className={isActivePath(item.path) ? 'router-link-active' : ''}
                  onClick={() => setMobileMenuVisible(false)}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="p-3">
          <Button
            label="Sign In"
            icon="pi pi-sign-in"
            className="w-full"
            onClick={() => {
              navigate('/login');
              setMobileMenuVisible(false);
            }}
          />
        </div>
      </Sidebar>
    </div>
  );
};

export default PublicLayout;